// $(function () {

// Модалка названия варианта заказа
if ($(document).find('#new-var-name').length > 0) {
    var newVarName = new SmModal({
        modalSelector: '#new-var-name',
        modalSpeed: 300,
        backgroundBlur: true,
        backgroundBlurValue: '10px',
    });
}

// Модалка подробной инфы о блюде (добавить)
if ($(document).find('#product-info').length > 0) {
    var productInfo = new SmModal({
        modalSelector: '#product-info',
        modalSpeed: 300,
        backgroundBlur: true,
        backgroundBlurValue: '10px',
    });
}

// Модалка подробной инфы о блюде (посмотреть)
if ($(document).find('#product-info_look').length > 0) {
    var productInfoLook = new SmModal({
        modalSelector: '#product-info_look',
        modalSpeed: 300,
        backgroundBlur: true,
        backgroundBlurValue: '10px',
        closeSelector: '.modal-close, .btn-close',
    });
}


// Расчет банкета - выбор пакета
if ($(document).find('#calc-packet').length > 0) {
    var calcPacket = new SmModal({
        modalSelector: '#calc-packet',
        modalSpeed: 300,
        backgroundBlur: true,
        backgroundBlurValue: '10px',
        beforeOpen: function () {
            $('#click_btn_id_dubl').val($('#click_btn_id').val());
        }
    });
}

// Куда отправить модалка
if ($(document).find('#sending').length > 0) {
    var sending = new SmModal({
        modalSelector: '#sending',
        modalSpeed: 300,
        backgroundBlur: true,
        backgroundBlurValue: '10px',
        beforeClose: function () {
            if ($('#sending').hasClass('can-redirect')) {
                var dayLink = $('.self__wp .self__general-line_date a');
                setCookie('setDate', true);
                setCookie('packetDay', dayLink.data('day'));
                setCookie('packetMonth', dayLink.data('month'));
                setCookie('packetYear', dayLink.data('year'));
                setCookie('currentOrderId', currentOrderId);
                // console.log(currentOrderId);
            }
        },
        afterClose: function () {
            if ($('#sending').hasClass('can-redirect')) {
                location.href = '/';
            }
        }
    });
}

// Отправлено на whatsapp
if ($(document).find('#watsappsend').length > 0) {
    var watsappsend = new SmModal({
        modalSelector: '#watsappsend',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
    });
}

// Отправлено на whatsapp другой номер
if ($(document).find('#watsapp-other').length > 0) {
    var watsappOther = new SmModal({
        modalSelector: '#watsapp-other',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
    });
}

// Отправлено на email
if ($(document).find('#mailsend').length > 0) {
    var mailsend = new SmModal({
        modalSelector: '#mailsend',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
    });
}

// Ссылка скопирована
if ($(document).find('#copylink').length > 0) {
    var copylink = new SmModal({
        modalSelector: '#copylink',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close',
        backgroundBlurValue: '10px',
    });
}

// pdf открылось в новом окне
if ($(document).find('#pdfopen').length > 0) {
    var pdfopen = new SmModal({
        modalSelector: '#pdfopen',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close',
        backgroundBlurValue: '10px',
    });
}




// Отправить себе на эмейл
if ($(document).find('#mail-yourself').length > 0) {
    var mailYourself = new SmModal({
        modalSelector: '#mail-yourself',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
    });
}

// Отправить себе на эмейл пакеты
if ($(document).find('#mail-yourself_pack').length > 0) {
    var mailYourselfPack = new SmModal({
        modalSelector: '#mail-yourself_pack',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
    });
}


// Модалка форма и две кнопки
if ($(document).find('#def-modal').length > 0) {
    var defMod = new SmModal({
        modalSelector: '#def-modal',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
    });
}


// Модалка форма и одна кнопка
if ($(document).find('#def-modal1').length > 0) {
    var defMod1 = new SmModal({
        modalSelector: '#def-modal1',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
    });
}


// Модалка с выпадающим списком
if ($(document).find('#def-modal2').length > 0) {
    var defMod2 = new SmModal({
        modalSelector: '#def-modal2',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
    });
}

// Бронь добавлена - модалка
if ($(document).find('#reserv').length > 0) {
    var reserv = new SmModal({
        modalSelector: '#reserv',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',

    });
}

// Обратиться в поддержку
if ($(document).find('#support').length > 0) {
    var support = new SmModal({
        modalSelector: '#support',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
    });
}


// Подробнее о клиенте
if ($(document).find('#aboutClient').length > 0) {
    var aboutClient = new SmModal({
        modalSelector: '#aboutClient',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterClose: function () {
            setTimeout(function () {
                $(document).find('.open-el').removeClass('open-el');
            }, 150)

            $('body').removeAttr('style');
            $('#aboutClient').removeClass('can-be-open');
            // Запрет на переход состояний инпутов
            var select = $('#aboutClient .about-client__order-type');
            console.log(select.find('.simple-select__item[data-value="3"]'));
            select.find('.simple-select__item[data-value="3"]').removeClass('nochange');
            select.find('.simple-select__item[data-value="4"]').removeClass('nochange');
        },
        afterOpen: function (e) {
            // Чтоб не вылезала модалка брони при соответствующих статусах
            setTimeout(function () {
                $('#aboutClient').addClass('can-be-open');
                var select = $('#aboutClient .about-client__order-type');
                select.find('.simple-select__item[data-value="3"]').addClass('nochange');
                select.find('.simple-select__item[data-value="4"]').addClass('nochange');
            }, 150)

        }
    });
}


// Расчет банкета
if ($(document).find('#calc-main').length > 0) {
    var calcMain = new SmModal({
        modalSelector: '#calc-main',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        beforeOpen: function () {
            $('#calc-main').find('.self__general-line.zal span').text($('.calendar__top').find('input:checked').siblings('label').find('p').text());
            $('#calc-main').removeClass('can-be-ajax');
        },
        // beforeClose: function () {
        // $('#click_btn_id').val('');
        // }
    });
}

// Бронь даты
if ($(document).find('#reserv-data').length > 0) {
    var reservData = new SmModal({
        modalSelector: '#reserv-data',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        beforeOpen: function () {
            $('#reserv-data').find('.self__general-line.zal span').text($('.calendar__top').find('input:checked').siblings('label').find('p').text());
        }
    });
}

// Расчет банкета - изменение зала и даты
if ($(document).find('#calc-date').length > 0) {
    var calcDate = new SmModal({
        modalSelector: '#calc-date',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterClose: function () {
            $(document).find('.edit-data').removeClass('edit-data');
        },
    });
}

// Обращение БМ
if ($(document).find('#appealbm').length > 0) {
    var appealbm = new SmModal({
        modalSelector: '#appealbm',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
    });
}

// Топ вопросов
if ($(document).find('#top-quest').length > 0) {
    var topQuest = new SmModal({
        modalSelector: '#top-quest',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
    });
}

// Все отзывы
if ($(document).find('#rewiews-mod').length > 0) {
    var rewiewsMod = new SmModal({
        modalSelector: '#rewiews-mod',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
    });
}
// О ресторане
if ($(document).find('#about-mod').length > 0) {
    var aboutMod = new SmModal({
        modalSelector: '#about-mod',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
    });
}

// О зале
if ($(document).find('#about-zal').length > 0) {
    var aboutZal = new SmModal({
        modalSelector: '#about-zal',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
    });
}
// Изменение гостей в клиенте
if ($(document).find('#change-guest').length > 0) {
    var changeGuest = new SmModal({
        modalSelector: '#change-guest',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterClose: function name() {
            $(document).find('.guest-edit').removeClass('guest-edit');
            $('#change-guest').find('form').removeClass('guest-form');
        }
    });
}

// Изменение гостей в клиенте 2
if ($(document).find('#change-guest_second').length > 0) {
    var changeGuestSec = new SmModal({
        modalSelector: '#change-guest_second',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterClose: function name() {
            $(document).find('.guest-edit').removeClass('guest-edit');
            $('#change-guest').find('form').removeClass('guest-form');
        }
    });
}

// Изменение поля в Клиенте
if ($(document).find('#change-name').length > 0) {
    var changeName = new SmModal({
        modalSelector: '#change-name',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close, .btn_white',
        backgroundBlurValue: '10px',
    });
}

// Изменение номера телефона\вотсапа
if ($(document).find('#change-number').length > 0) {
    var changeNumber = new SmModal({
        modalSelector: '#change-number',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterClose: function () {
            $('#change-number').find('form').removeClass('change-phone change-whatsapp');
        },
    });
}

// Изменение email
if ($(document).find('#changemail').length > 0) {
    var changeMail = new SmModal({
        modalSelector: '#changemail',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterClose: function () {
            // $('#change-number').find('form').removeClass('change-phone change-whatsapp');
        },
    });
}

// Изменение комментария
if ($(document).find('#change-comment').length > 0) {
    var changeComment = new SmModal({
        modalSelector: '#change-comment',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterClose: function () {
            // $('#change-number').find('form').removeClass('change-phone change-whatsapp');
        },
    });
}

// Тип мероприятия
if ($(document).find('#change-type').length > 0) {
    var changeType = new SmModal({
        modalSelector: '#change-type',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterClose: function () {
            // $('#change-number').find('form').removeClass('change-phone change-whatsapp');
        },
    });
}

// Вы уверены в удалении заявки?
if ($(document).find('#you-shure').length > 0) {
    var youShure = new SmModal({
        modalSelector: '#you-shure',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterClose: function () {
            if ($('main').hasClass('self')) {
                setTimeout(function () {
                    $('.redirect-link').removeClass('preredirect');
                }, 150)
            }
            // $('#change-number').find('form').removeClass('change-phone change-whatsapp');
        },
    });
}

// Дата занята
if ($(document).find('#data-broned').length > 0) {
    var dataBroned = new SmModal({
        modalSelector: '#data-broned',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterClose: function () {
            // $('#change-number').find('form').removeClass('change-phone change-whatsapp');
        },
    });
}

// Дата занята
if ($(document).find('#soon_mod').length > 0) {
    var soonModal = new SmModal({
        modalSelector: '#soon_mod',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterClose: function () {
            // $('#change-number').find('form').removeClass('change-phone change-whatsapp');
        },
    });
}

// Выберите пакет
if ($(document).find('#sel_packet').length > 0) {
    var selPacket = new SmModal({
        modalSelector: '#sel_packet',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterOpen: function () {
            $('#sel_packet').css('z-index', 5005);
        },
        afterClose: function () {
            $('#sel_packet').css('z-index', 'auto');
        },
    });
}

if ($(document).find('#open_pdf').length > 0) {
    var openPdf = new SmModal({
        modalSelector: '#open_pdf',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterClose: function () {
            // $('#change-number').find('form').removeClass('change-phone change-whatsapp');
        },
    });
}

if ($(document).find('#mail-yourself_pack_ready').length > 0) {
    var openPdfReady = new SmModal({
        modalSelector: '#mail-yourself_pack_ready',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterClose: function () {
            // $('#change-number').find('form').removeClass('change-phone change-whatsapp');
        },
    });
}

if ($(document).find('#about-copy').length > 0) {
    var aboutCopy = new SmModal({
        modalSelector: '#about-copy',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterClose: function () {
            // $('#change-number').find('form').removeClass('change-phone change-whatsapp');
        },
    });
}

// Изменить расчет или создать новый
if ($(document).find('#change_raschet').length > 0) {
    var changeRaschet = new SmModal({
        modalSelector: '#change_raschet',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterClose: function () {
            // $('#change-number').find('form').removeClass('change-phone change-whatsapp');
        },
    });
}

// Изменить расчет или создать новый
if ($(document).find('#selfAlert').length > 0) {
    var selfAlert = new SmModal({
        modalSelector: '#selfAlert',
        modalSpeed: 300,
        backgroundBlur: true,
        closeSelector: '.modal-close, .btn-close',
        backgroundBlurValue: '10px',
        afterClose: function () {
            // $('#change-number').find('form').removeClass('change-phone change-whatsapp');
        },
    });
}

$(document).on('click', '.new-var-add', function (e) {
    e.preventDefault();
    if (!$(this).hasClass('btn-neok')) {
        newVarName.openModal();
        $('#new-var-name input').val($('#var_count').val());
        $('#new-var-name .input-block').addClass('noempty');
    }
});

// Модалка подробнее о блюде

$(document).on('click', '.sel-product_add .sel-product__info, .sel-product_look .sel-product__info', function (e) {
    e.preventDefault();

    //     // productInfo.openModal();
});

$(document).on('click', '.product_look .product__name, .product_look .product__img, .product_add .product__name, .product_add .product__img, .sel-product .sel-product__info', function (e) {
    e.preventDefault();
    var $this = $(this),
        dataAjax = {
            _token: tokenData,
        },
        lookModal = $('#product-info_look');
    if ($this.parents('.product_look').length > 0) {
        var colvo = $this.parents('.product').find('.colvo').text();
    }



    $.ajax({
        url: '/option/food/' + $this.parents('.product, .sel-product').data('product'),
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            console.log(result);

            var units = 'мл.';
            if (result.type == 1) {
                units = 'гр.'
            }

            var thisWeight = `<b>${result.weight} ${units}</b> `,
                thisDescr = result.description;

            if (thisDescr == null) {
                thisDescr = '';
            }

            if (thisWeight == null) {
                thisWeight = '';
            }

            lookModal.find('.modal-title').text(result.name);
            lookModal.find('.product__img img').attr('src', result.image);
            lookModal.find('.product-modal__descr').html(thisWeight + thisDescr);
            lookModal.find('.product__price .price').text(result.cost);


            if ($this.parents('.product_look').length > 0) {
                lookModal.find('.product__bottom-right').html(`${colvo * result.cost}<span>₽</span>`);
                lookModal.find('.product__price .num').text(colvo);
            } else {
                lookModal.find('.product__bottom').hide()
            }

            productInfoLook.openModal();
        }
    });
});

// $(document).on('click', '.sending .btn_green', function (e) {
//     e.preventDefault();
//     watsappsend.openModal();
// });

$(document).on('click', '.sending .btn_mail.btn-ajx', function (e) {
    e.preventDefault();
    // mailsend.openModal();
});

$(document).on('click', '.sending .btn_other', function (e) {
    e.preventDefault();
    watsappOther.openModal();
});

// $(document).on('click', '.sending .btn_copy', function (e) {
//     e.preventDefault();

// });

$('#copylink .btn-close').on('click', function (e) {
    e.preventDefault();
    copylink.closeModal();
});

$('#pdfopen .btn-close').on('click', function (e) {
    e.preventDefault();
    pdfopen.closeModal();
});

$('#mailsend .btn-close').on('click', function (e) {
    e.preventDefault();
    mailsend.closeModal();
});

$('#soon_mod .btn-close').on('click', function (e) {
    e.preventDefault();
    soonModal.closeModal();
});

$('#appealbm .btn-close').on('click', function (e) {
    e.preventDefault();
    appealbm.closeModal();
});

$('.change_raschet .btn-close').on('click', function (e) {
    e.preventDefault();
    changeRaschet.closeModal();
});

$('#sel_packet .btn-close').on('click', function (e) {
    e.preventDefault();
    selPacket.closeModal();
});

$(document).on('click', '#sending .mail-change:not(.soon-modal)', function (e) {
    e.preventDefault();
    mailYourself.openModal();
});

$(document).on('click', '#selfAlert .btn-close', function (e) {
    e.preventDefault();
    selfAlert.closeModal();
});

$(document).on('click', '.calc-packet .yourself:not(.soon-modal)', function (e) {

    if ($('.calc-packet__form').find('input[type=checkbox]:checked').length == 0) {
        e.preventDefault();
        selPacket.openModal();
    } else {
        e.preventDefault();
        mailYourselfPack.openModal();
    }
});

$(document).on('click', '.back-to-calc', function (e) {
    e.preventDefault();
    youShure.openModal();
});

$(document).on('click', '.custom-item__right-calculate, .calc_banket', function (e) {
    e.preventDefault();
    calcMain.openModal();
    var $this = $(this);

    // Обнуление при открытии расчета под калькулятором
    if ($(this).hasClass('custom-item__right-calculate')) {
        $('#click_btn_id').val('');
        $('.calc-main__form')[0].reset();
        resetSelect('.calc-main__form .simple-select');
        $('.calc-main__form .input-block').removeClass('noempty');
        // Запись текущего зала в дата атрибут
        if ($(document).find('.calendar__top').length > 0) {
            $('#calc-main').find('.self__general-line.zal').data('zal-id', $(document).find('.calendar__top input:checked').val());
        }

    }

    // Вывод гостей в селект
    var thisModal = $('#calc-main'),
        dataAjax = {
            _token: tokenData,
        },
        guestList = thisModal.find('.simple-select_guest .simple-select__list'),
        ajaxUrl = '/option/room/limits/' + $('.calendar__top').find('input[type="radio"]:checked').val();

    // Подгрузка гостей в запросе в модалке
    if ($(this).parents('.check__contant').length > 0) {
        ajaxUrl = '/option/room/limits/' + $(this).parents('.check__contant').find('.check__contant-item_zal').data('zal-id');
    }

    $.ajax({
        url: ajaxUrl,
        type: 'POST',
        data: dataAjax,
        success: function (data) {

            // Очистка списка гостей
            guestList.html('');
            // Вывод списка с количеством гостей
            for (let index = data.min; index < data.max + 1; index++) {
                guestList.append(`<li class="simple-select__item" data-value="${index}" role="option">${index} гостей</li>`);
            }
            // Выбор первого значения из списка

            // Хотелка - Гостей пусть не будет предвыбрано, а написано: Количество гостей
            if ($this.hasClass('custom-item__right-calculate')) {
                thisModal.find('.simple-select_guest input').val('');
                thisModal.find('.simple-select_guest .simple-select__selected').text('Количество гостей');
            } else {
                guestList.find('.simple-select__item').eq(0).click();
            }
        }
    });

});


// Функция вывода дополнительных источников и типов мероприятия
function typeSocAjax() {
    dataAjax = {
        _token: tokenData,
    };

    $.ajax({
        url: '/restaurant/sources',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            var modals = $('#calc-main, #reserv-data'),
                modalsLists = modals.find('.simple-select_source .simple-select__list');
            modalsLists.html('');
            for (key in result) {
                modalsLists.append(`
                <li class="simple-select__item" data-value="${key}" role="option">${result[key]}</li>
                `);
            };
        }
    });

    $.ajax({
        url: '/restaurant/events',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            // console.log(result);

            var modals = $('#calc-main, #reserv-data'),
                modalsLists = modals.find('.simple-select_type .simple-select__list');
            modalsLists.html('');
            for (key in result) {
                modalsLists.append(`
                <li class="simple-select__item" data-value="${key}" role="option">${result[key]}</li>
                `);
            };
        }
    });
}

$(window).on('load', function () {
    typeSocAjax();
});



$(document).on('click', '.custom-item__right-booking', function (e) {
    e.preventDefault();
    reservData.openModal();
    var $this = $(this);

    // Обнуление при открытии расчета под калькулятором
    if ($(this).hasClass('custom-item__right-booking')) {
        // $('#click_btn_id').val('');
        $('.reserv-data__form')[0].reset();
        resetSelect('.reserv-data__form .simple-select');
        $('.reserv-data__form .input-block').removeClass('noempty');
        // Запись текущего зала в дата атрибут
    }

    // Вывод гостей в селект
    var thisModal = $('#reserv-data'),
        dataAjax = {
            _token: tokenData,
        },
        guestList = thisModal.find('.simple-select_guest .simple-select__list');

    $.ajax({
        url: '/option/room/limits/' + $('.calendar__top').find('input[type="radio"]:checked').val(),
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            console.log(data);

            // Очистка списка гостей
            guestList.html('');
            // Вывод списка с количеством гостей
            for (let index = data.min; index < data.max + 1; index++) {
                guestList.append(`<li class="simple-select__item" data-value="${index}" role="option">${index} гостей</li>`);
            }
            // Выбор первого значения из списка

            // Хотелка - Гостей пусть не будет предвыбрано, а написано: Количество гостей
            if ($this.hasClass('custom-item__right-booking')) {
                thisModal.find('.simple-select_guest input').val('');
                thisModal.find('.simple-select_guest .simple-select__selected').text('Количество гостей');
            } else {
                guestList.find('.simple-select__item').eq(0).click();
            }
        }
    });


});

$(document).on('click', '.open-data-mod', function (e) {
    e.preventDefault();


    var dataAjax = {
            // order_id: openEl.find('.applications__el-top-btn').data('id'),
            // is_room_checked: checkedStatus,
            _token: tokenData,
        },
        $this = $(this),
        calcModal = $('#calc-date'),
        calcModalzalId = $this.parents('.calc-main__form').find('.self__general-line.zal').data('zal-id'),
        datapickerMod = $('.calc-data__datapicker').datepicker().data('datepicker');
    console.log(calcModalzalId);
    $('.calc-data__datapicker').find('.-selected-').removeClass('-selected-');
    var separDate = $this.parents('.calc-main__form').find('.self__general-line.date span').text().split('.');
    var summDate = separDate[2] + '-' + separDate[1] + '-' + separDate[0];
    var currDate = new Date(summDate);

    console.log(summDate);
    datapickerMod.selectDate(currDate);


    $.ajax({
        url: '/calendar',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            console.log(result);

            calcModal.find('.calc-data__radio').html('');
            for (let index = 0; index < result.rooms.length; index++) {
                const room = result.rooms[index];

                calcModal.find('.calc-data__radio').append(`
                <label class="calc-data__zal">
                    <input type="radio" name="zal" value="${room.id}" hidden="">
                    <div class="calc-data__zal-wp">
                        <div class="calc-data__zal-name">${room.name}</div>
                        <div class="calc-data__zal-guest" data-min=${room.min} data-max=${room.max}>${room.min} - ${room.max} гостей</div>
                        <div class="checkbox__icon">
                            <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.125 1.375L3.875 6.62477L1.25 4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                    </div>
                </label>
            `);
            }

            if (calcModalzalId.length > 0) {
                calcModal.find('.calc-data__radio input[value=' + calcModalzalId + ']').parent().click();
            }


            calcDate.openModal();


            // if (openEl.find('.viewed-hall').length > 0) {
            //     // Визуализация в карточке
            //     if (thisStatus == true) {
            //         openEl.find('.viewed-hall').addClass('active');
            //     } else {
            //         openEl.find('.viewed-hall').removeClass('active');
            //     }
            // }

        }
    });


});

$(document).on('click', '.calc-data__back', function (e) {
    e.preventDefault();
    calcDate.closeModal();
});

$(document).on('click', '#watsappsend .btn-close', function (e) {
    e.preventDefault();
    watsappsend.closeModal();
});

$(document).on('click', '#mail-yourself_pack_ready .btn-close', function (e) {
    e.preventDefault();
    openPdfReady.closeModal();
});

$(document).on('click', '.manager a', function (e) {
    e.preventDefault();
    appealbm.openModal();
});

$(document).on('click', '.about__left p a, .about__mob p a', function (e) {
    e.preventDefault();
    aboutMod.openModal();
});

// Модалка с открытием PDF
$(document).on('click', '.calc-packet__bottom .print', function (e) {

    e.preventDefault();
    $('#pdfopen').addClass('can_detail_open');

    if ($('.calc-packet__form').find('input[type=checkbox]:checked').length == 0) {
        selPacket.openModal();
    } else {

        var allPack = [],
            allOptions = [];

        $('.calc-packet__vars>.calc-packet__check').find('input[type=checkbox]').each(function (e) {
            var $this = $(this)
            if ($this.is(':checked')) {
                allPack.push($this.val());
            }
        })

        $('.calc-packet__vars .about-client__raschet .calc-packet__check').find('input[type=checkbox]').each(function (e) {
            var $this = $(this)
            if ($this.is(':checked')) {
                allOptions.push($this.val());
            }
        });
        // Код заявки
        // console.log($('#calc_packet_order_id').val());

        let dataAjax = {
            packs: allPack,
            options: allOptions,
            date: $('#calc_packet_date').val(),
            guest_count: $('#calc_packet_guest').val(),
            room_id: $('#calc_packet_zal').val(),
            _token: tokenData,
        }

        $.ajax({
            url: '/order/' + $('#calc_packet_order_id').val() + '/pdf',
            type: 'POST',
            data: dataAjax,
            success: function (data) {
                var result = data;
                console.log(result);
                // Открытие модалки со ссылкой на пдф
                openPdf.openModal();
                $('#open_pdf').find('.btn').attr('href', result)
            }
        })

    }

});

$('#open_pdf .btn').on('click', function (e) {

    openPdf.closeModal();
    pdfopen.openModal();
});

$('#pdfopen .btn').on('click', function (e) {
    pdfopen.closeModal();
    setTimeout(function () {
        $('#pdfopen').removeClass('can_detail_open');
    }, 100);
});



// $(document).on('click', '.halls__el-btn, .halls__el-img', function (e) {
//     e.preventDefault();
//     aboutZal.openModal();

// });

$(document).on('click', '.support__link', function (e) {
    e.preventDefault();
    support.openModal();
});

$(document).on('click', '.zal-date-edit', function (e) {
    e.preventDefault();
    calcDate.openModal();
    var $this = $(this);

    $this.parents('.self__general-line').parent().find('.zal-date-edit').parent().addClass('edit-data');

    if ($this.parents('.self').length > 0) {
        // console.log($(this).parents('self1'));
        var modalCalendar = $('.calc-data__datapicker').datepicker().data('datepicker');
        modalCalendar.selectDate(new Date($this.data('year'), $this.data('month') - 1, $this.data('day')));
    }
});

$(document).on('click', '.edit-name', function (e) {
    e.preventDefault();
    changeName.openModal();
    $('#change-name .edit-name').addClass('noempty');
    $('#change-name .edit-name input').val($(this).siblings('.name').text());

});

$(document).on('click', '.edit-guest', function (e) {
    e.preventDefault();
    changeGuest.openModal();

    $(this).parents('.self__general-line').addClass('guest-edit');
    $('.change-guest__form .simple-select__item[data-guest=' + $(this).data('guest') + ']').click();
});

$(document).on('click', '#change-guest .btn-close', function (e) {
    e.preventDefault();
    changeGuest.closeModal();
});

$(document).on('click', '#change-name .btn_white', function (e) {
    e.preventDefault();
    changeName.closeModal();
});

$(document).on('click', '#change-type .btn_white', function (e) {
    e.preventDefault();
    changeType.closeModal();
});

$(document).on('click', '.soon-modal', function (e) {
    e.preventDefault();
    soonModal.openModal();
});

$(document).on('click', '#reserv .btn-close', function (e) {
    e.preventDefault();
    reserv.closeModal();
});

$(document).on('click', '#you-shure .btn-close', function (e) {
    e.preventDefault();
    youShure.closeModal();
});

$(document).on('click', '#product-info_look .btn-close', function (e) {
    e.preventDefault();
    productInfoLook.closeModal();
});

$(document).on('click', '#change-comment .btn_white', function (e) {
    e.preventDefault();
    changeComment.closeModal();
});

$(document).on('click', '#data-broned .btn_white', function (e) {
    e.preventDefault();
    dataBroned.closeModal();
});

// Изменение номера телефона\вотсапа
$(document).on('click', '.whatsapp-change, .phone-change', function (e) {
    e.preventDefault();
    changeNumber.openModal();
    var $this = $(this),
        changeModal = $('#change-number');

    changeModal.find('.input-block input').val($this.siblings('p').find('span').text());
    changeModal.find('.input-block').addClass('noempty');

    if ($this.hasClass('phone-change')) {
        changeModal.find('form').addClass('change-phone');
        changeModal.find('.modal-title span').text('телефона');
        changeModal.find('.input-block .label span').text('телефона');
    } else {
        changeModal.find('form').addClass('change-whatsapp');
        changeModal.find('.modal-title span').text('WhatsApp');
        changeModal.find('.input-block .label span').text('для WhatsApp');
    }

});

// Изменение комментария
$(document).on('click', '.edit-comment', function (e) {
    e.preventDefault();
    changeComment.openModal();
    var $this = $(this),
        changeModal = $('#change-comment');

    changeModal.find('.input-block textarea').val($this.parents('.about-client__info').find('.about-client__comment').text());
    changeModal.find('.input-block').addClass('noempty');
});


function copytext(el) {
    var $tmp = $("<textarea>");
    $("body").append($tmp);
    $tmp.val($(el).attr('data-copy'));
    $tmp.select();
    document.execCommand("copy");
    $tmp.remove();
}

$(document).on('click', '.about-client__copy', function (e) {
    e.preventDefault();
    copytext($(this));
    copylink.openModal();
});

// Копировать ссылку в модалке отправить\распечатать из подробнее
$('#about-copy .copylink').on('click', function (e) {
    e.preventDefault();
    copytext($(this));

});

// Кнопка открыть в pdf в модалке отправить\распечатать из подробнее
$('#about-copy .print').on('click', function (e) {
    e.preventDefault();

});

$(document).on('click', '#aboutClient .edit-guest', function (e) {
    e.preventDefault();
    changeGuest.openModal();

    var dataAjax = {
            _token: tokenData,
        },
        guestMod = $('#change-guest');

    guestMod.find('form').addClass('guest-change');


    $.ajax({
        url: '/order/guests',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            console.log(result);
            guestMod.find('.simple-select__list').html('');
            for (let index = result.min; index < result.max + 1; index++) {
                guestMod.find('.simple-select__list').append(`
                <li class="simple-select__item" data-value="${index}" role="option" data-guest="${index}">${index} гостей</li>`);
            }
            console.log($('#aboutClient .self__general-line.guest span').text());
            console.log(guestMod.find('.simple-select__list .simple-select__list[data-value=' + $('#aboutClient .self__general-line.guest span').text() + ']'));
            setTimeout(function () {
                guestMod.find('.simple-select__list .simple-select__item[data-value=' + $('#aboutClient .self__general-line.guest span').text() + ']').click();
            }, 100)

        }
    });
});

$(document).on('click', '#aboutClient .edit-email', function (e) {
    e.preventDefault();
    changeMail.openModal();

    var $this = $(this);
    changeModal = $('#changemail');

    changeModal.find('.input-block input').val($this.siblings('p').find('span').text());
    changeModal.find('.input-block').addClass('noempty');
});

$(document).on('click', '#aboutClient .type-change', function (e) {
    e.preventDefault();
    changeType.openModal();

    var $this = $(this);
    changeModal = $('#change-type');
    changeModal.find('.simple-select .simple-select__item[data-value=' + $this.parents('.self__general-line').data('type') + ']').click();
});

$(document).on('click', '.nosend', function (e) {
    e.preventDefault();
});

$(document).on('click', '.btn_copy:not(.nosend)', function (e) {
    e.preventDefault();

    copytext($(this));

    var allPack = [],
        allOptions = [],
        thisBtn = $(this);

    $('.calc-packet__vars>.calc-packet__check').find('input[type=checkbox]').each(function (e) {
        var $this = $(this)
        if ($this.is(':checked')) {
            allPack.push($this.val());
        }
    })

    $('.calc-packet__vars .about-client__raschet .calc-packet__check').find('input[type=checkbox]').each(function (e) {
        var $this = $(this)
        if ($this.is(':checked')) {
            allOptions.push($this.val());
        }
    });

    thisBtn.addClass('nosend');
    setTimeout(function () {
        thisBtn.removeClass('nosend');
    }, 2000);


    // var inquiryId = '';

    if ($(document).find('#inqury_id').length > 0) {
        var inquiryId = $(document).find('#inqury_id').val();
    } else {
        var inquiryId = $('#click_btn_id').val();
    }

    let dataAjax = {
        order_link: $('#calc_packet_order_id').val(),
        packs: allPack,
        options: allOptions,
        email: $('#other_email').val(),
        whatsapp: $('#other_wathsapp').val(),
        date: $('#calc_packet_date').val(),
        guest_count: $('#calc_packet_guest').val(),
        room_id: $('#calc_packet_zal').val(),
        send_type: '',
        inquiry_id: inquiryId,
        _token: tokenData,
    }




    $.ajax({
        url: '/order/send',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            console.log(result);

            if ($('main').hasClass('clients')) {
                setTimeout(function () {
                    if ($('.applications__btns .applications__buttons-wrap').find('.applications__btn.active').length > 0) {
                        console.log('tyt ya');
                        $('.applications__btns .applications__buttons-wrap .applications__btn.active').click().click();
                    }
                }, 50)
            }

            // Для закрытия модалки с последубщим редиректом в календарь
            if ($('main').hasClass('self')) {
                $('#sending').addClass('can-redirect');
            }
            // sending.closeModal();
            // $('#click_btn_id').val(''),
            copylink.openModal();
            $(document).find('.calendar .day.active, .datepicker--cell-day.-selected-').click();

            console.log(thisBtn);
        }
    })
});


// Открытие модалки изменить расчет или создать новый
$(document).on('click', '.self__btn_option', function (e) {
    e.preventDefault();

    $('#change_raschet .btn_change').attr('href', $(this).data('edit'));
    $('#change_raschet .btn_2').attr('href', $(this).attr('href'));
    console.log();
    changeRaschet.openModal();
});



///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Окрас текста и бекграунда селекта
$(document).on('click', '.about-client__order-type .simple-select__item:not(.nochange)', function () {
    var parSel = $(this).parents('.simple-select');

    console.log(parSel);

    parSel.find('.simple-select__main').css({
        'background': $(this).data('back'),
        'border-color': $(this).css('color'),
    });
    parSel.find('.simple-select__selected').css('color', $(this).css('color'));
});

// Маски
// $('.phone-mask, .phone-mask1').inputmask({
//     "mask": "+*(999) 999-9999",
//     "showMaskOnHover": false,
//     "definitions": {
//         '*': {
//             validator: "[7,8]",
//         }
//     }
// });

function phone_mask() {
    $(".phone-mask, .phone-mask1").each(function () {

        var $input = $(this);
        $input.attr("type", "text").mask(
            '+0 (000) 000-00-00', {
                translation: {
                    'Z': {
                        pattern: /[7-8]/,
                        optional: false
                    },
                    'N': {
                        pattern: /[+]/,
                        optional: true
                    }
                },
                // placeholder: "+7 (923) 111-11-11",
                autoclear: false
            })

    });
}

phone_mask();

// добавление\удаление плейсолдера и всегда 7ка в начале
$(".phone-mask, .phone-mask1").on('focus input', function (e) {
    var $this = $(this);
    if ($this.val().length > 0) {
        $this.attr('placeholder', '')
    } else {
        $this.attr('placeholder', '+7 (923) 111-11-11');
    }

    // Чтоб всегда была 7ка в начале
    if ($this.val()[1] != 7) {
        $this.val($this.val().replace($this.val()[1], 7));
    }

});

$(".phone-mask, .phone-mask1").on('focusout', function (e) {
    var $this = $(this);
    $this.attr('placeholder', '')
});



$('.mail-mask').inputmask({
    mask: "*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@***{1,20}[.*{2,6}][.*{1,2}]",
    greedy: false,
    "showMaskOnHover": false,
    onBeforePaste: function (pastedValue, opts) {
        pastedValue = pastedValue.toLowerCase();
        return pastedValue.replace("mailto:", "");
    },
    definitions: {
        '*': {
            validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~\-]",
            casing: "lower"
        }
    }
});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// Модалка названия варианта заказа - Форма
$('.var-name__form').on('submit', function (e) {
    e.preventDefault();

    var $this = $(this);
    var inpBl = $this.find('.input-block');
    var inp = $(this).find('input').val().length,
        selectedMenu = {},
        selectedServices = {};

    if (inp > 2) {
        inpBl.removeClass('wrong');
    } else {
        inpBl.addClass('wrong');
    }

    $('.self__selected_desc').find('.sel-product').each(function (e) {
        var thisInput = $(this).find('input');
        selectedMenu[$(this).data('product')] = thisInput.val();
    });

    $('.self__key').find('.self__key-item input[type=hidden], input[type=checkbox]').each(function () {
        if ($(this).is(':checked')) {
            selectedServices[$(this).data('id')] = 1;
        } else if ($(this).attr('type') == 'hidden') {
            selectedServices[$(this).data('id')] = $(this).val();
        }
    });




    var dataAjax = {
        name: $this.find('input').val(),
        foods: selectedMenu,
        services: selectedServices,
        date: $('#date_val1').val(),
        guest_count: $('#guest_col').val(),
        room_id: $('#selected_zal').val(),
        _token: tokenData,
    }

    if ($(document).find('#option_id').length > 0) {
        dataAjax['option_id'] = $('#option_id').val();
    } else {
        dataAjax['pack_id'] = $('#pack_zal').val()
    }

    // console.log(dataAjax);

    //
    // calcPacket.openModal();
    // newVarName.closeModal();
    //

    if ($this.find('.wrong').length == 0) {
        // console.log('sub');
        // calcPacket.openModal();
        // newVarName.closeModal();

        $.ajax({
            url: '/option/store/' + $('#order_key').val(),
            type: 'POST',
            data: dataAjax,
            success: function (data) {
                var result = data;

                var packetModal = $('#calc-packet');
                packetModal.addClass('after-var');
                console.log(result);
                if ($('main').hasClass('self_noauth')) {
                    window.location.href = result.redirect;
                } else {
                    currentOrderId = result.order.id;

                    // Запись в кнопку копировать ссылку
                    $('#sending .btn_copy').attr('data-copy', result.order.full_link);
                    $('#sending .whatsapp-ajx b').text(result.client.phone);
                    $('#sending .whatsapp-ajx').attr('href', 'https://api.whatsapp.com/send/?phone=' + result.client.phone + '&text=%D0%9F%D1%80%D0%B5%D0%B4%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%B4%D0%BB%D1%8F%20%D0%B2%D0%B0%D1%88%D0%B5%D0%B3%D0%BE%20%D0%B1%D0%B0%D0%BD%D0%BA%D0%B5%D1%82%D0%B0%3A%20 ' + result.order.full_link + '');
                    console.log($('#sending .whatsapp-ajx').attr('href'));
                    console.log(result.client.email);
                    if (result.client.email == 'none') {
                        $('#sending .btn_mail.btn-ajx').hide();
                    } else {
                        $('#sending .btn_mail.btn-ajx').show();
                        $('#sending .btn_mail.btn-ajx').find('b').text(result.client.email)
                    }
                    newVarName.closeModal();
                    calcPacket.openModal();
                    $('#calc_packet_order_id').val(result.order.order_link);
                    // console.log($('#calc_packet_order_id').val());

                    // Запись в скрытые инпуты в модалке пакетов
                    packetModal.find('#calc_packet_zal').val(result.order.room_id);
                    packetModal.find('#calc_packet_guest').val(result.order.guest_count);
                    packetModal.find('#calc_packet_date').val(result.order.date);

                    // Визуализация в модалке пакетов
                    packetModal.find('.self__general-line.zal span').text(result.order.room_name);
                    var separDate = result.order.date.split('-');
                    packetModal.find('.self__general-line.date span').text(separDate[2] + '.' + separDate[1] + '.' + separDate[0]);
                    packetModal.find('.self__general-line.guest span').text(result.order.guest_count);
                    packetModal.find('.self__general-line.name span').text(result.order.name);
                    packetModal.find('.self__general-line_phone span').text(result.order.phone);


                    $('.calc-packet__check').html('');

                    $('.calc-packet__form').attr('action', '/menu/' + result.order.order_link)

                    if (result.packs.length > 0) {
                        for (let index = 0; index < result.packs.length; index++) {
                            const pack = result.packs[index];

                            var eatWeight = pack.amount;
                            var descr = pack.description;
                            if (pack.description == null) {
                                descr = '';
                            }

                            // Выделение КГ и Грамм если больше 1000 грамм
                            if (eatWeight < 1001) {
                                var eatWeightWrite = `<span>${eatWeight} гр./чел.</span>`
                            } else {
                                // Превращение с троку иначе длинна не считается
                                var eStart = eatWeight.toString().length - 3,
                                    eEnd = eatWeight.toString().length,
                                    eatWeightGramm = eatWeight.toString().slice(eStart, eEnd),
                                    eatWeightKg = (eatWeight / 1000).toString().split(".")[0];
                                var eatWeightWrite = `<span> ${eatWeightKg} кг. ${eatWeightGramm} гр./чел.</span>`
                            }


                            $('.calc-packet__check').append(`
                            <label>
                                <input type="checkbox" name="pack_id" value="${pack.id}" hidden="">
                                <div class="check__contant">
                                    <div class="label">${pack.name}</div>
                                    <div class="checkbox__icon">
                                        <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.125 1.375L3.875 6.62477L1.25 4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="check__contant-top">
                                        <p>${triplets(pack.cost)}₽</p>${eatWeightWrite}
                                    </div>
                                    <div class="calc-packet__cont">
                                        ${descr}
                                    </div>
                                    <a href="${result.order.order_link}" data-id="${pack.id}">Посмотреть меню и условия</a>
                                </div>
                            </label>
                        `);

                        }
                    }

                    // Очистка списка отправленных расчетов
                    packetModal.find('.about-client__raschet').remove();

                    // Вывод отправленных расчетов в модалку

                    if (result.options.length > 0) {

                        packetModal.find('.calc-packet__vars').append(`
                            <div class="about-client__raschet">
                                <div class="about-client__calc-title">Индивидуальные расчеты для отправки</div>
                                <div class="calc-packet__check"></div>
                            </div>
                            `);

                        $('.about-client__raschet').show();
                        for (let index = 0; index < result.options.length; index++) {
                            const raschetItem = result.options[index];
                            var zalName = raschetItem.room,
                                itemDescr = raschetItem.description;
                            eatWeight = raschetItem.amount;

                            if (itemDescr == null) {
                                itemDescr = '';
                            }
                            // Выделение КГ и Грамм если больше 1000 грамм
                            if (eatWeight < 1001) {
                                var eatWeightWrite = `<span>${eatWeight} гр./чел.</span>`
                            } else {
                                // Превращение с троку иначе длинна не считается
                                var eStart = eatWeight.toString().length - 3,
                                    eEnd = eatWeight.toString().length,
                                    eatWeightGramm = eatWeight.toString().slice(eStart, eEnd),
                                    eatWeightKg = (eatWeight / 1000).toString().split(".")[0];
                                var eatWeightWrite = `<span> ${eatWeightKg} кг. ${eatWeightGramm} гр./чел.</span>`
                            }

                            // Если зала нет
                            if (raschetItem.room == null) {
                                zalName = '—'
                            }

                            // Выбрать текущий вариант
                            var check = '';
                            if (raschetItem.id == result.option.id) {
                                check = 'checked=ckecked'
                            }

                            $('.about-client__raschet .calc-packet__check').append(`
                                <label>
                                    <input type="checkbox" name="pack_rasch" value="${raschetItem.id}" ${check} hidden="">
                                    <div class="check__contant">
                                        <div class="label">${raschetItem.name}</div>
                                        <div class="checkbox__icon">
                                            <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.125 1.375L3.875 6.62477L1.25 4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            </svg>
                                        </div>
                                        <div class="check__contant-top">
                                            <p>${triplets(raschetItem.cost)}₽</p>${eatWeightWrite}
                                        </div>
                                        <div class="calc-packet__cont">
                                            ${itemDescr}
                                        </div>

                                    </div>
                                </label>
                            `);
                            // {/* <a href="${result.order.order_link}" data-id="${raschetItem.id}">Посмотреть меню и условия</a> */}
                        }

                    } else {
                        $('.about-client__raschet').hide();
                    }



                }

                // $this[0].reset();
            }
        });
    }

});


$('.calc-packet__form').on('submit', function (e) {
    if (!$('.calc-packet__form').parents('.sm-modal').hasClass('after-var')) {
        e.preventDefault();

        if ($('.calc-packet__form').find('input[type=checkbox]:checked').length == 0) {
            e.preventDefault();
            selPacket.openModal();
        } else {
            var $this = $(this);

            console.log('sub');

            calcPacket.closeModal();
            sending.openModal();

            //   $.ajax({
            //     url: $this.attr('action'),
            //     type: $this.attr('method'),
            //     data: $this.serialize(),
            //     success: function () {
            //         // $this[0].reset();
            //     }
            // });
        }


    }
});

// Модалка другого номера wathsapp

$('.watsapp-other__form').on('submit', function (e) {
    e.preventDefault();



    var $this = $(this);
    var inpBl = $this.find('.input-block');
    var inp = $(this).find('input').val().length;

    var thisWind = window;

    if (inp > 2) {
        inpBl.removeClass('wrong');
    } else {
        inpBl.addClass('wrong');
    }

    var allPack = [],
        allOptions = [],
        thisBtn = $(this),
        sentType = 'wathsapp';

    $('.calc-packet__vars>.calc-packet__check').find('input[type=checkbox]').each(function (e) {
        var $this = $(this)
        if ($this.is(':checked')) {
            allPack.push($this.val());
        }
    })

    $('.calc-packet__vars .about-client__raschet .calc-packet__check').find('input[type=checkbox]').each(function (e) {
        var $this = $(this)
        if ($this.is(':checked')) {
            allOptions.push($this.val());
        }
    })

    //
    // watsappsend.openModal();
    // watsappOther.closeModal();
    //

    if ($this.find('.wrong').length == 0) {

        console.log('sub');
        $('#other_wathsapp').val(inpBl.find('input').val());
        window.open('https://api.whatsapp.com/send/?phone=' + replaceAlll($('#other_wathsapp').val(), ' ', '') + '&text=%D0%9F%D1%80%D0%B5%D0%B4%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%B4%D0%BB%D1%8F%20%D0%B2%D0%B0%D1%88%D0%B5%D0%B3%D0%BE%20%D0%B1%D0%B0%D0%BD%D0%BA%D0%B5%D1%82%D0%B0%3A%20 ' + $('#sending .btn_copy').attr('data-copy'));

        // var inquiryId = '';

        if ($(document).find('#inqury_id').length > 0) {
            var inquiryId = $(document).find('#inqury_id').val();
        } else {
            var inquiryId = $('#click_btn_id').val();
        }

        let dataAjax = {
            order_link: $('#calc_packet_order_id').val(),
            packs: allPack,
            options: allOptions,
            email: $('#other_email').val(),
            whatsapp: $('#other_wathsapp').val(),
            send_type: sentType,
            inquiry_id: inquiryId,
            room_id: $('#calc_packet_zal').val(),
            guest_count: $('#calc_packet_guest').val(),
            date: $('#calc_packet_date').val(),
            _token: tokenData,
        }

        console.log(dataAjax);

        $.ajax({
            url: '/order/send',
            type: 'POST',
            data: dataAjax,
            success: function (data) {
                var result = data;
                // $('#click_btn_id').val('');
                console.log(result);
                $('#watsappsend').find('p span').text($('#other_wathsapp').val());
                watsappsend.openModal();
                watsappOther.closeModal();

                // Для закрытия модалки с последубщим редиректом в календарь
                if ($('main').hasClass('self')) {
                    $('#sending').addClass('can-redirect');
                }

                if ($('main').hasClass('clients')) {
                    setTimeout(function () {
                        if ($('.applications__btns .applications__buttons-wrap').find('.applications__btn.active').length > 0) {
                            console.log('tyt ya');
                            $('.applications__btns .applications__buttons-wrap .applications__btn.active').click().click();
                        }
                    }, 50)
                }

                setTimeout(function () {
                    sending.closeModal();
                }, 500);

                $('#other-whatsapp-link').attr('href', 'https://api.whatsapp.com/send/?phone=' + replaceAlll($('#other_wathsapp').val(), ' ', '') + '&text=%D0%9F%D1%80%D0%B5%D0%B4%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%B4%D0%BB%D1%8F%20%D0%B2%D0%B0%D1%88%D0%B5%D0%B3%D0%BE%20%D0%B1%D0%B0%D0%BD%D0%BA%D0%B5%D1%82%D0%B0%3A%20 ' + $('#sending .btn_copy').attr('data-copy'));
                // setTimeout(function () {
                //     $('#other-whatsapp-link').click();
                // }, 100)

                // window.open('https://api.whatsapp.com/send/?phone=' + $('#other_wathsapp').val().replaceAll(' ', '') + '&text=%D0%9F%D1%80%D0%B5%D0%B4%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%B4%D0%BB%D1%8F%20%D0%B2%D0%B0%D1%88%D0%B5%D0%B3%D0%BE%20%D0%B1%D0%B0%D0%BD%D0%BA%D0%B5%D1%82%D0%B0%3A%20 ' + $('#sending .btn_copy').attr('data-copy'));
                // window.open('https://api.whatsapp.com/send/?phone=' + $('#other_wathsapp').val().replaceAll(' ', ''));
                $(document).find('.calendar .day.active, .datepicker--cell-day.-selected-').click();
            }
        })
        // $this[0].reset();
        watsappsend.openModal();

    }

});


$('#other-whatsapp-link').on('click', function () {
    console.log('click');
    console.log($(this).attr('href'));
})



// Модалка изменения количество гостей не для страницы расчета
if (!$('main').hasClass('self')) {
    $('.change-guest__form').on('submit', function (e) {
        e.preventDefault();
        var $this = $(this);
        var currGuest = $this.find('.simple-select__item.is-active').data('guest');

        $(document).find('.edit-guest').data('guest', currGuest);
        $(document).find('.edit-guest').parent().find('p span').text(currGuest);

        if ($(document).find('.edit-guest').parents('.self').length > 0) {
            // Запись количества гостей в скрытый инпут
            $(document).find('.edit-guest').siblings('input').val(currGuest);
            // Пересчет веса еды по гостям
            eatWeight();
        }



        if (!$this.hasClass('guest-change')) {
            let dataAjax = {
                guest_count: currGuest,
                restaurant_id: $("#selected_zal").val(),
                _token: tokenData,
            }

            console.log(dataAjax);

            $.ajax({
                url: '/search/rooms',
                type: 'POST',
                data: dataAjax,
                success: function (data) {
                    var result = data;
                    console.log(result);
                    changeGuest.closeModal();

                    $('#calc-date .calc-data__radio').html('');

                    // Вывод залов в модалку
                    for (let index = 0; index < result.length; index++) {
                        const zalItem = result[index];
                        $('#calc-date .calc-data__radio').append(`
                    <label class="calc-data__zal">
                        <input type="radio" name="zal" value="${zalItem.id}" hidden="" checked="">
                        <div class="calc-data__zal-wp">
                            <div class="calc-data__zal-name">${zalItem.name}</div>
                            <div class="calc-data__zal-guest">${zalItem.description}</div>
                            <div class="checkbox__icon">
                                <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.125 1.375L3.875 6.62477L1.25 4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </div>
                        </div>
                    </label>
                `);
                    }

                }
            });
        } else {

            // Изменение гостей из модалки aboutClient -> подробнее которая
            let dataAjax = {
                guest_count: currGuest,
                order_id: $('#order_id').val(),
                _token: tokenData,
            }

            $.ajax({
                url: '/order/edit/guest_count',
                type: 'POST',
                data: dataAjax,
                success: function (data) {
                    var result = data;
                    console.log(result);
                    changeGuest.closeModal();
                    $this.find('form').removeClass('guest-change');

                    $(document).find('.calendar .day.active, .datepicker--cell-day.-selected-').click();
                }
            });
        }


    });
} else {
    $('.change-guest__form').on('submit', function (e) {
        e.preventDefault();
        var $this = $(this);
        var currGuest = $this.find('.simple-select__item.is-active').data('value');
        // Выбор количества гостей в модалке, визуализация и запись в скрытый инпут
        $('#guest_col').val(currGuest);
        console.log('Выбрано гостей ' + currGuest);
        // Визуализация
        $(document).find('.self__general-line_guest span').text(currGuest);
        // Закрытие модалки
        changeGuest.closeModal();

        setTimeout(function () {
            // пересчет веса еды при изменении количества гостей
            selfSumm();
            makeEatCat();
            eatWeight();
            eatDrinks();
            eatSumm()
        }, 150)
    });
}


// Изменение имени
$('.change-name__form').on('submit', function (e) {
    e.preventDefault();

    var $this = $(this);

    $('#aboutClient .modal-title .name').text($this.find('.edit-name input').val());

    let dataAjax = {
        order_id: $('#order_id').val(),
        name: $this.find('.input-block input').val(),
        _token: tokenData,
    }

    $.ajax({
        url: '/order/edit/name',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            console.log(result);
            changeName.closeModal();

            // $('.open-el').find('.applications__el-title').text($this.find('.input-block input').val());
            $(document).find('.calendar .day.active, .datepicker--cell-day.-selected-').click();
            $('body').removeAttr('style');
        }
    });
});

// Изменение номера телефона\вотсапа
$('.change-number__form').on('submit', function (e) {
    e.preventDefault();

    var $this = $(this);

    // Для изменения телефон
    if ($this.hasClass('change-phone')) {
        let dataAjax = {
            order_id: $('#order_id').val(),
            phone: $this.find('.input-block input').val(),
            _token: tokenData,
        };

        console.log(dataAjax);

        $.ajax({
            url: '/order/edit/phone',
            type: 'POST',
            data: dataAjax,
            success: function (data) {
                var result = data;
                console.log(result);
                changeNumber.closeModal();
                // Визуализация в модалке
                $('#aboutClient .self__general-line.phone span').text($this.find('.input-block input').val());
                // Обновление календаря
                $(document).find('.calendar .day.active, .datepicker--cell-day.-selected-').click();
                $this.find('.input-block .message').text(result.responseJSON.message).css({
                    'visibility': 'hidden',
                    opacity: 0
                });
            },
            error: function (data) {
                var result = data;
                console.log(result);
                $this.find('.input-block .message').text(result.responseJSON.message).css({
                    'visibility': 'visible',
                    opacity: 1
                });
                console.log(result.responseJSON.message);
            }
        });
    } else {
        // Для изменения вотсапа
        let dataAjax = {
            order_id: $('#order_id').val(),
            whatsapp: $this.find('.input-block input').val(),
            _token: tokenData,
        };

        console.log(dataAjax);

        $.ajax({
            url: '/order/edit/whatsapp',
            type: 'POST',
            data: dataAjax,
            success: function (data) {
                var result = data;
                console.log(result);
                changeNumber.closeModal();
                // Визуализация в модалке
                $('#aboutClient .self__general-line.whatsapp span').text($this.find('.input-block input').val());
                // Обновление календаря
                $(document).find('.calendar .day.active, .datepicker--cell-day.-selected-').click();
                $this.find('.input-block .message').text(result.responseJSON.message).css({
                    'visibility': 'hidden',
                    opacity: 0
                });
            },
            error: function (data) {
                var result = data;
                console.log(result);
                $this.find('.input-block .message').text(result.responseJSON.message).css({
                    'visibility': 'visible',
                    opacity: 1
                });
                console.log(result.responseJSON.message);
            }
        });
    }


});

// Изменение email
$('.changemail__form').on('submit', function (e) {
    e.preventDefault();

    var $this = $(this);

    let dataAjax = {
        order_id: $('#order_id').val(),
        email: $this.find('.input-block input').val(),
        _token: tokenData,
    };

    console.log(dataAjax);

    $.ajax({
        url: '/order/edit/email',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            console.log(result);
            changeMail.closeModal();
            // Визуализация в модалке
            $('#aboutClient .self__general-line.mail span').text($this.find('.input-block input').val());
            // Обновление календаря
            // $(document).find('.calendar .day.active, .datepicker--cell-day.-selected-').click();
            $this.find('.input-block .message').text(result.responseJSON.message).css({
                'visibility': 'hidden',
                opacity: 0
            });
        },
        error: function (data) {
            var result = data;
            console.log(result);
            $this.find('.input-block .message').text(result.responseJSON.message).css({
                'visibility': 'visible',
                opacity: 1
            });
            console.log(result.responseJSON.message);
        }
    });
});


// Изменение комментария
$('.change-comment__form').on('submit', function (e) {
    e.preventDefault();

    var $this = $(this);

    let dataAjax = {
        order_id: $('#order_id').val(),
        comment: $this.find('.input-block textarea').val(),
        _token: tokenData,
    };

    console.log(dataAjax);

    $.ajax({
        url: '/order/edit/comment',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            console.log(result);
            changeComment.closeModal();
            // Визуализация в модалке
            $('#aboutClient .about-client__comment').text($this.find('.input-block textarea').val());
            if ($this.find('.input-block textarea').val().length > 0) {
                $('#aboutClient .about-client__comment').show();
            } else {
                $('#aboutClient .about-client__comment').hide();
            }
            // Обновление календаря
            $(document).find('.calendar .day.active, .datepicker--cell-day.-selected-').click();

            // Обновление сетки (фильтров) при смене статуса зала
            if (document.querySelector('main').classList.contains('clients') && document.querySelector('.applications__buttons') != null) {
                document.querySelector('.applications__btn.active').click();
            }
        }
    });
});

// Изменение статуса
$(document).on('click', '.about-client__order-type .simple-select__item:not(.is-active)', function (e) {
    e.preventDefault();

    // console.log($('#order_id').val());


    if ($('#aboutClient').hasClass('can-be-open')) {
        var $this = $('.about-client__order-type input'),
            reservModal = $('#reserv-data'),
            button = $(this),
            thisModal = $('#aboutClient');
        $this.val($(this).data('value'));

        let dataAjax = {
            order_id: $('#order_id').val(),
            status: $this.val(),
            _token: tokenData,
        };

        console.log(dataAjax);

        $.ajax({
            url: '/order/edit/status',
            type: 'POST',
            data: dataAjax,
            success: function (data) {
                var result = data;
                console.log(result);
                changeComment.closeModal();
                // Визуализация в модалке

                console.log($('.calendar__top').find('input:checked').val());
                console.log($('#date_val').val());

                // Обновление календаря
                setTimeout(function () {
                    $(document).find('.calendar .day.active, .datepicker--cell-day.-selected-').click();
                }, 100)


                if ($this.val() == 3 || $this.val() == 4) {
                    if (button.hasClass('nochange') || !button.hasClass('noopen')) {
                        reservData.openModal();
                    }
                    reservModal.find('.input-block.name').addClass('noempty').find('input').val(thisModal.find('.modal-title .name').text());
                    reservModal.find('.input-block.phone').addClass('noempty').find('input').val(thisModal.find('.self__general-line.phone span').text());
                    reservModal.find('.simple-select_type .simple-select__item[data-value=' + thisModal.find('.self__general-line.type').data('type') + ']').click();
                    reservModal.find('.simple-select_zanatost .simple-select__item[data-value=' + $this.val() + ']').click();
                    reservModal.find('.simple-select_zanatost .simple-select__item[data-value=' + $this.val() + ']').click();
                    reservModal.find('.input-block textarea').val(thisModal.find('.about-client__comment').text());
                    if (thisModal.find('.about-client__comment').text().length > 0) {
                        reservModal.find('.input-block textarea').parent().addClass('noempty');
                    }
                } else {
                    var orderStatus = '',
                        orderName = $this.val();
                    console.log($this.val());
                    if ($this.val() == 1) {
                        orderStatus = `<div class="applications__el-tag new">#Новая заявка</div>`;
                    } else if ($this.val() == 2) {
                        orderStatus = `<div class="applications__el-tag success">#В работе</div>`;
                    } else if ($this.val() == 5) {
                        orderStatus = `<div class="applications__el-tag refusal">#Отказ</div>`;
                    }
                    $(document).find('.open-el .applications__el-tag').replaceWith('' + orderStatus + '');
                    console.log(orderName);
                    $(document).find('.open-el').attr('data-hash', Number(orderName));
                    // console.log($(document).find('.open-el').data('hash'));
                    console.log($(document).find('.open-el'));
                }

                // обновление фильтра
                setTimeout(function () {
                    if ($('.applications__btns .applications__buttons-wrap').find('.applications__btn.active').length > 0) {
                        console.log('tyt ya');
                        $('.applications__btns .applications__buttons-wrap .applications__btn.active').click().click();
                    }
                }, 50)




                console.log($('.calendar__top').find('input[type="radio"]'));
                if ($('.calendar__top').find('input[type="radio"]').length > 0) {
                    var guestList = reservModal.find('.simple-select_guest .simple-select__list');

                    var dataAjax1 = {
                        _token: tokenData,
                    }

                    $.ajax({
                        url: '/option/room/limits/' + $('.calendar__top').find('input[type="radio"]').val(),
                        type: 'POST',
                        data: dataAjax1,
                        success: function (data) {

                            // Очистка списка гостей
                            guestList.html('');
                            // Вывод списка с количеством гостей
                            for (let index = data.min; index < data.max + 1; index++) {
                                guestList.append(`<li class="simple-select__item" data-value="${index}" role="option">${index} гостей</li>`);
                            }
                            // Выбор первого значения из списка
                            guestList.find('.simple-select__item[data-value=' + thisModal.find('.about-client__info .self__general-line.guest span').text() + ']').click();
                        }
                    });
                }


            }
        });
    }




});

// Изменение типа
$('.change-type__form').on('submit', function (e) {
    e.preventDefault();

    var $this = $(this);

    let dataAjax = {
        order_id: $('#order_id').val(),
        event_type_id: $this.find('.simple-select__item.is-active').data('value'),
        _token: tokenData,
    };

    console.log(dataAjax);

    $.ajax({
        url: '/order/edit/type',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            console.log(result);
            changeType.closeModal();
            // Визуализация в модалке
            $('#aboutClient .self__general-line.type span').text($this.find('.simple-select__item.is-active').text());
            // Обновление календаря
            // $(document).find('.calendar .day.active, .datepicker--cell-day.-selected-').click();
        }
    });
});


// Модалка редактирования даты и зала (#calc-data)
$('.calc-data__form').on('submit', function (e) {
    e.preventDefault();
    var selData = $('#select_data'),
        selZal = $('.calc-data__zal').find('input[type=radio]:checked'),
        calcForm = $('.calc-data__form'),
        packetModal = $('#calc-packet');
    console.log(replaceAlll(selData.val(), '-', '/'));

    // Проход по редактируемым блокам даты и зала
    $(document).find('.edit-data .zal-date-edit, .open-data-mod').each(function () {

        $('#date_val1').val(selData.val());
        $('#date_val').val(selData.val());
        // Выделение из выбранной даты дня\месяца\года
        var selectedDate = new Date(replaceAlll(selData.val(), '-', '/')),
            selectedDateDay = selectedDate.getDate(),
            selectedDateYear = selectedDate.getFullYear(),
            // Корректировка месяца с 0-11 до 1-12
            selectedDateMonthCorrect = selectedDate.getMonth() + 1;
        $(this).data('day', selectedDateDay)
        $(this).data('month', selectedDateMonthCorrect)
        $(this).data('year', selectedDateYear)

        // Добавления нулей в числах меньше 10 для визуализации
        if (selectedDateMonthCorrect < 10) {
            selectedDateMonthCorrect = '0' + selectedDateMonthCorrect
        }
        if (selectedDateDay < 10) {
            selectedDateDay = '0' + selectedDateDay
        }

        //

        if ($(this).hasClass('data-edit')) {
            // Вывод выбранной даты
            $(this).siblings('p').find('span').text(selectedDateDay + '.' + selectedDateMonthCorrect + '.' + selectedDateYear);
        }

        if ($(this).hasClass('zal-edit')) {
            // Вывод выбранного зала
            $(this).siblings('p').find('span').text(selZal.siblings('.calc-data__zal-wp').find('.calc-data__zal-name').text());
            // Запись значения зала в скрытый инпут
            $('#selected_zal').val(selZal.val());
        }
        if ($(this).hasClass('open-data-mod')) {
            // Вывод выбранного зала
            $(this).parents('.calc-main__form').find('.self__general-line.date span').text(selectedDateDay + '.' + selectedDateMonthCorrect + '.' + selectedDateYear);
            packetModal.find('.self__general-line.date span').text(selectedDateDay + '.' + selectedDateMonthCorrect + '.' + selectedDateYear);
            $(this).parents('.calc-main__form').find('.self__general-line.date').data('zal-date', selData.val());
            packetModal.find('.self__general-line.date').data('zal-date', selData.val());
            $(this).parents('.calc-main__form').find('.self__general-line.zal span').text(calcForm.find('.calc-data__radio input:checked').siblings('.calc-data__zal-wp').find('.calc-data__zal-name').text());
            packetModal.find('.self__general-line.zal span').text(calcForm.find('.calc-data__radio input:checked').siblings('.calc-data__zal-wp').find('.calc-data__zal-name').text());
            $(this).parents('.calc-main__form').find('.self__general-line.zal').data('zal-id', calcForm.find('.calc-data__radio input:checked').val());
            packetModal.find('.self__general-line.zal').data(calcForm.find('.calc-data__radio input:checked').val());
            $(this).parents('.calc-main__form').find('.self__general-line.zal').removeClass('wrong');
            // console.log(packetModal.find('.self__general-line.zal'));
            // Запись значения зала в скрытый инпут
            $('#selected_zal').val(selZal.val());

            // Корректировка гостей в модалке расчета
            var min = selZal.siblings('.calc-data__zal-wp').find('.calc-data__zal-guest').data('min'),
                max = selZal.siblings('.calc-data__zal-wp').find('.calc-data__zal-guest').data('max');
            $('#calc-main .simple-select_guest .simple-select__list').html('');
            for (let index = min; index < max + 1; index++) {
                $('#calc-main .simple-select_guest .simple-select__list').append(`
                <li class="simple-select__item" data-value="${index}" role="option">${index} гостей</li>`)
            }

            $('#calc-main .simple-select_guest .simple-select__item').eq(0).click();
        }


    });

    calcDate.closeModal();

    // Сабмит для обновления пакетов и прочего
    if ($('.calc-main').hasClass('can-be-ajax')) {
        $('.calc-main__form').submit();
    }
});

$(document).on('click', '.calc-packet-data', function (e) {
    e.preventDefault();

    $('#calc-main .self__general-line.zal .open-data-mod').click();
});






// Kalendar /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Kalendar /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Kalendar /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Kalendar /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Kalendar /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Kalendar /////////////////////////////////////////////////////////////////////////////////////////////////////////////////

var currentYear = new Date().getFullYear(),
    currentMounth = new Date().getMonth(),
    currentDay = new Date().getDate(),
    currentDate = new Date(currentYear, currentMounth, currentDay);

// var redDate = [
//     '2021,4,29',
//     '2021,8,8',
//     '2021,8,9',
//     '2021,10,22',
//     '2021,10,23',
//     '2021,11,9',
// ];
// var particalRedDate = [
//     '2021,4,30',
//     '2021,8,10',
//     '2021,8,11',
//     '2021,10,24',
//     '2021,10,25',
//     '2021,11,8',
// ];
var mounthRussian = {
    0: 'января',
    1: 'февраля',
    2: 'марта',
    3: 'апреля',
    4: 'мая',
    5: 'июня',
    6: 'июля',
    7: 'августа',
    8: 'сентября',
    9: 'октября',
    10: 'ноября',
    11: 'декабря',
};

$('.calc-data__datapicker').datepicker({
    // minDate: currentDate,
    inline: true,
    onRenderCell: function (date, cellType) {
        var thisStringDate = date.getFullYear() + '.' + date.getMonth() + '.' + date.getDate();
        for (var i = 0; i < redDate.length; i++) {
            if (redDate[i] == thisStringDate && cellType == 'day') {
                return {
                    classes: 'red',
                }
            }
        }
        for (var i = 0; i < particalRedDate.length; i++) {
            var currentDate = date.getDate();
            if (particalRedDate[i] == thisStringDate && cellType == 'day') {
                return {
                    html: currentDate + '<span class="dp-note"></span>',
                    classes: 'particalRed',
                }
            }
        }

        // Окрас в серый прошедших дней
        if ((date.getMonth() < currentMounth && date.getFullYear() <= currentYear || date.getDate() < currentDay && date.getMonth() == currentMounth && date.getFullYear() == currentYear || date.getFullYear() < currentYear) && cellType == 'day') {
            return {
                classes: 'grey-col',
            }
        }
        // Окрас в серый прошедших месяцев
        if ((date.getMonth() < currentMounth && date.getFullYear() == currentYear || date.getFullYear() < currentYear) && cellType == 'month') {
            return {
                classes: 'grey-col',
            }
        }
        // Окрас в серый прошедших лет
        if ((date.getFullYear() < currentYear) && cellType == 'year') {
            return {
                classes: 'grey-col',
            }
        }
    },
    onSelect: function (formattedDate, date, inst) {

        if (date != undefined && date.length != 0) {
            var thisYear = date.getFullYear(),
                thisMonth = date.getMonth() + 1,
                thisDay = date.getDate();


            if (thisMonth < 10) {
                var thisDayFull = thisYear + '-0' + thisMonth + '-' + thisDay;
            } else {
                var thisDayFull = thisYear + '-' + thisMonth + '-' + thisDay;
            }
        }


        // console.log(thisDayFull);

        if ($('main').hasClass('self')) {
            // Запись отформатированной даты в скрытый инпут
            $('#select_data').val(thisDayFull);
            console.log($('#select_data').val());

            let dataAjax = {
                room_id: $("#selected_zal").val(),
                guest_count: $('#guest_col').val(),
                date: $('#select_data').val(),
                _token: tokenData,
            }

            console.log(dataAjax);


            $.ajax({
                url: '/check/date',
                type: 'POST',
                data: dataAjax,
                success: function (data) {
                    var result = data;

                    console.log(result);
                    // Очистка врапперов пакетов
                    $('.calculation__packet-line').html('');

                    setTimeout(() => {
                        if ($('.datepicker--cell-day.-selected-').hasClass('red')) {
                            $('.calc-data__datapicker-wp .custom-item--modal .custom-item--modal__top .day').text(date.getDate());
                            $('.calc-data__datapicker-wp .custom-item--modal .custom-item--modal__top .month').text(mounthRussian[date.getMonth()]);
                            $('.calc-data__datapicker-wp .custom-item--modal .custom-item--modal__top .status').text('занято');
                            $('.calc-data__datapicker-wp .custom-item--modal').addClass('active closed').removeClass('partical');
                            $('.calendar-wrapper').addClass('broned').removeClass('broned-partical empty');
                            $('.booked__el-tag span').text('ПОЛНОСТЬЮ');
                            $('.applications__title h4 .day').text(date.getDate());
                            $('.applications__title h4 .month').text(mounthRussian[date.getMonth()]);
                            $('.applications__title h4 .year').text(date.getFullYear());
                        } else if ($('.datepicker--cell-day.-selected-').hasClass('particalRed')) {
                            $('.calc-data__datapicker-wp .custom-item--modal .custom-item--modal__top .day').text(date.getDate());
                            $('.calc-data__datapicker-wp .custom-item--modal .custom-item--modal__top .month').text(mounthRussian[date.getMonth()]);
                            $('.calc-data__datapicker-wp .custom-item--modal .custom-item--modal__top .status').text('частично занято');
                            $('.calc-data__datapicker-wp .custom-item--modal').addClass('active partical').removeClass('closed');
                            $('.calc-data__datapicker-wp').addClass('broned-partical').removeClass('broned empty');
                            $('.booked__el-tag span').text('ЧАСТИЧНО');
                            $('.applications__title h4 .day').text(date.getDate());
                            $('.applications__title h4 .month').text(mounthRussian[date.getMonth()]);
                            $('.applications__title h4 .year').text(date.getFullYear());

                            // Вывод списка услуг в кастомном блоке календаря
                            servicesList(result);
                        } else {
                            $('.calc-data__datapicker-wp .custom-item--modal .custom-item--modal__top .day').text(date.getDate());
                            $('.calc-data__datapicker-wp .custom-item--modal .custom-item--modal__top .month').text(mounthRussian[date.getMonth()]);
                            $('.calc-data__datapicker-wp .custom-item--modal .custom-item--modal__top .status').text('свободно');
                            $('.calc-data__datapicker-wp .custom-item--modal').addClass('active').removeClass('closed partical');
                            $('.calendar .months-container .custom-item').addClass('active').removeClass('partical closed');
                            $('.calendar-wrapper').addClass('empty').removeClass('broned-partical broned');
                            $('.applications__title h4 .day').text(date.getDate());
                            $('.applications__title h4 .month').text(mounthRussian[date.getMonth()]);
                            $('.applications__title h4 .year').text(date.getFullYear());

                            // Вывод списка услуг в кастомном блоке календаря
                            servicesList(result);
                        }



                        if (!$('.datepicker--cell-day.-selected-').hasClass('red')) {
                            $('.calculation__block_step4').fadeIn();
                        } else {
                            $('.calculation__block_step4').fadeOut();
                        }

                    }, 300);
                }
            })
        }
        if ($('main').hasClass('clients')) {
            // Запись отформатированной даты в скрытый инпут
            if (date != undefined && date.length != 0) {
                $('#select_data').val(thisDayFull);
                console.log($('#select_data').val());
            }

        }



    },
    navTitles: {
        days: 'MM yyyy'
    },
    prevHtml: '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.625 23.7498C13.8723 23.75 14.1141 23.6768 14.3198 23.5395C14.5255 23.4023 14.6859 23.2071 14.7806 22.9787C14.8753 22.7502 14.9002 22.4988 14.852 22.2563C14.8039 22.0137 14.6848 21.7909 14.51 21.616L8.77749 15.8835C8.54315 15.6491 8.41151 15.3312 8.41151 14.9998C8.41151 14.6683 8.54315 14.3504 8.77749 14.116L14.5 8.38351C14.7344 8.14896 14.866 7.83091 14.8659 7.49932C14.8658 7.16774 14.7339 6.84978 14.4994 6.61539C14.2648 6.38101 13.9468 6.24939 13.6152 6.24951C13.2836 6.24963 12.9656 6.38146 12.7312 6.61602L6.99999 12.3485C6.29698 13.0517 5.90204 14.0054 5.90204 14.9998C5.90204 15.9941 6.29698 16.9478 6.99999 17.651L12.7325 23.3835C12.8496 23.5006 12.9888 23.5933 13.142 23.6562C13.2952 23.7191 13.4594 23.7509 13.625 23.7498Z" fill="#675BE1"/><path d="M22.375 23.75C22.6214 23.7482 22.8618 23.6737 23.066 23.5356C23.2702 23.3976 23.429 23.2023 23.5225 22.9743C23.616 22.7463 23.64 22.4957 23.5915 22.2541C23.543 22.0125 23.4242 21.7906 23.25 21.6163L16.6387 15L23.25 8.38377C23.4657 8.14621 23.5818 7.83481 23.5742 7.51402C23.5666 7.19324 23.436 6.88765 23.2094 6.66051C22.9827 6.43338 22.6774 6.30211 22.3566 6.29387C22.0359 6.28563 21.7242 6.40107 21.4862 6.61627L13.9862 14.1163C13.7519 14.3507 13.6202 14.6686 13.6202 15C13.6202 15.3315 13.7519 15.6494 13.9862 15.8838L21.4862 23.3838C21.6028 23.5004 21.7414 23.5929 21.894 23.6557C22.0465 23.7186 22.21 23.7506 22.375 23.75Z" fill="#675BE1"/></svg>',
    nextHtml: '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.375 23.7498C16.1277 23.75 15.8859 23.6768 15.6802 23.5395C15.4745 23.4023 15.3141 23.2071 15.2194 22.9787C15.1247 22.7502 15.0998 22.4988 15.148 22.2563C15.1961 22.0137 15.3152 21.7909 15.49 21.616L21.2225 15.8835C21.4568 15.6491 21.5885 15.3312 21.5885 14.9998C21.5885 14.6683 21.4568 14.3504 21.2225 14.116L15.5 8.38351C15.2656 8.14896 15.134 7.83091 15.1341 7.49932C15.1342 7.16774 15.2661 6.84978 15.5006 6.61539C15.7352 6.38101 16.0532 6.24939 16.3848 6.24951C16.7164 6.24963 17.0344 6.38146 17.2688 6.61602L23 12.3485C23.703 13.0517 24.098 14.0054 24.098 14.9998C24.098 15.9941 23.703 16.9478 23 17.651L17.2675 23.3835C17.1504 23.5006 17.0112 23.5933 16.858 23.6562C16.7048 23.7191 16.5406 23.7509 16.375 23.7498Z" fill="#675BE1"/><path d="M7.62505 23.75C7.37861 23.7482 7.13819 23.6737 6.93401 23.5356C6.72983 23.3976 6.57101 23.2023 6.4775 22.9743C6.38399 22.7463 6.35998 22.4957 6.40847 22.2541C6.45696 22.0125 6.5758 21.7906 6.75005 21.6163L13.3613 15L6.75005 8.38377C6.53434 8.14621 6.41825 7.83481 6.4258 7.51402C6.43336 7.19324 6.56399 6.88765 6.79064 6.66051C7.01729 6.43338 7.3226 6.30211 7.64337 6.29387C7.96414 6.28563 8.27579 6.40107 8.5138 6.61627L16.0138 14.1163C16.2481 14.3507 16.3798 14.6686 16.3798 15C16.3798 15.3315 16.2481 15.6494 16.0138 15.8838L8.5138 23.3838C8.39716 23.5004 8.25857 23.5929 8.10604 23.6557C7.9535 23.7186 7.79003 23.7506 7.62505 23.75Z" fill="#675BE1"/></svg>'
});

/////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////

var aboutZalSlider = {
    width: Infinity,
    swiperContainer: '.about-zal__slider',
    swiperContainerWrap: '.about-zal__slider .about-zal__slider-wrap',
    swiperContainerSlide: '.about-zal__slider .about-zal__slider-el',
    swiperVariable: undefined,
    swiperUpdateTime: undefined,
    swiperSettings: {
        slidesPerView: 'auto',
        speed: 500,
        watchOverflow: true,
        freeMode: true,
        // spaceBetween: 15,
        loop: false,
        navigation: {
            nextEl: '.about-zal__slider-nav .about-zal__slider-next',
            prevEl: '.about-zal__slider-nav .about-zal__slider-prev',
        },
    },
}

initCustomSwiper(aboutZalSlider);
$(window).resize(function () {
    initCustomSwiper(aboutZalSlider);
});



// });
$('.mail-yourself__form_sending').on('submit', function (e) {

    e.preventDefault();
    var $this = $(this);
    if ($this.find('input').val().length > 0) {

        var allPack = [],
            allOptions = [],
            thisBtn = $(this);

        $('.calc-packet__vars>.calc-packet__check').find('input[type=checkbox]').each(function (e) {
            var $this = $(this)
            if ($this.is(':checked')) {
                allPack.push($this.val());
            }
        })

        $('.calc-packet__vars .about-client__raschet .calc-packet__check').find('input[type=checkbox]').each(function (e) {
            var $this = $(this)
            if ($this.is(':checked')) {
                allOptions.push($this.val());
            }
        })

        $('#other_email').val($this.find('input').val());

        // var inquiryId = '';

        if ($(document).find('#inqury_id').length > 0) {
            var inquiryId = $(document).find('#inqury_id').val();
        } else {
            var inquiryId = $('#click_btn_id').val();
        }

        let dataAjax = {
            order_link: $('#calc_packet_order_id').val(),
            packs: allPack,
            options: allOptions,
            email: $('#other_email').val(),
            whatsapp: $('#other_wathsapp').val(),
            date: $('#calc_packet_date').val(),
            guest_count: $('#calc_packet_guest').val(),
            room_id: $('#calc_packet_zal').val(),
            send_type: 'email',
            inquiry_id: inquiryId,
            _token: tokenData,
        }


        $.ajax({
            url: '/order/send',
            type: 'POST',
            data: dataAjax,
            success: function (data) {
                var result = data;
                console.log(result);

                // Для закрытия модалки с последубщим редиректом в календарь
                if ($('main').hasClass('self')) {
                    $('#sending').addClass('can-redirect');
                }

                if ($('main').hasClass('clients')) {
                    setTimeout(function () {
                        if ($('.applications__btns .applications__buttons-wrap').find('.applications__btn.active').length > 0) {
                            console.log('tyt ya');
                            $('.applications__btns .applications__buttons-wrap .applications__btn.active').click().click();
                        }
                    }, 50)
                }
                sending.closeModal();
                mailYourself.closeModal();
                // $('#click_btn_id').val(''),



                console.log(thisBtn);
                $('#mailsend').find('p span').text($('#other_email').val());
                mailsend.openModal();
                $(document).find('.calendar .day.active, .datepicker--cell-day.-selected-').click();
            }
        })
    }

});

// Отправить пакеты себе на э-мейл
$('.mail-yourself__form_pack').on('submit', function (e) {
    e.preventDefault();

    var formBtn = $(this).find('.btn'),
        resultModText = $('#mail-yourself_pack_ready .modal-title');

    formBtn.attr('disabled', true);
    console.log('submit');

    var allPack = [],
        allOptions = [];

    $('.calc-packet__vars>.calc-packet__check').find('input[type=checkbox]').each(function (e) {
        var $this = $(this)
        if ($this.is(':checked')) {
            allPack.push($this.val());
        }
    })

    $('.calc-packet__vars .about-client__raschet .calc-packet__check').find('input[type=checkbox]').each(function (e) {
        var $this = $(this)
        if ($this.is(':checked')) {
            allOptions.push($this.val());
        }
    });



    // Модалка чере 5 сек если нет ответа от сервера
    var modalMustOpen = 1,
        resultTimer = setTimeout(function () {
            resultModText.text('Ваше письмо передано в обработку');
            openPdfReady.openModal();
            modalMustOpen = 0;
            formBtn.attr('disabled', false);
        }, 500);

    // Код заявки
    // console.log($('#calc_packet_order_id').val());

    let dataAjax = {
        packs: allPack,
        options: allOptions,
        date: $('#calc_packet_date').val(),
        guest_count: $('#calc_packet_guest').val(),
        room_id: $('#calc_packet_zal').val(),
        _token: tokenData,
        email: $(this).find('input[name="mail"]').val(),
    }

    $.ajax({
        url: '/order/' + $('#calc_packet_order_id').val() + '/send/pdf',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            console.log(result);
            clearTimeout(resultTimer);
            if (modalMustOpen != 0) {
                resultModText.text('Письмо отправлено на ваш e-mail');
                // Открытие модалки что ссылка отправлена
                openPdfReady.openModal();
            }

            formBtn.attr('disabled', false);
        }
    })


});



// Чтоб фансибокс закрывался
$(document).find('[data-fancybox]').fancybox({
    mobile: {
        preventCaptionOverlap: false,
        idleTime: false,
        // clickContent: function (current, event) {
        //     $.fancybox.close();
        // },
        clickSlide: function (current, event) {
            $.fancybox.close();
        },
        dblclickContent: function (current, event) {
            $.fancybox.close();
        },
        // dblclickSlide: function (current, event) {
        //     $.fancybox.close();
        // }
    },
});
